import { useCallback, useEffect, useState } from 'react';

/**
 * Opening asks are one model call; two minutes without them means the run
 * stalled, and saying "in a moment" any longer would be a lie.
 */
export const KICKOFF_TIMEOUT_MS = 2 * 60 * 1000;

/**
 * Turns an open-ended "Robbie is drafting" into a bounded wait. The clock
 * restarts per thread and on every retry, and clears as soon as the server
 * stops reporting the kickoff as pending.
 */
export const useOutreachKickoffTimeout = (pending: boolean, threadKey: string) => {
  const [timedOut, setTimedOut] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setTimedOut(false);
    if (!pending) return undefined;
    const timer = setTimeout(() => setTimedOut(true), KICKOFF_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [pending, threadKey, attempt]);

  const restart = useCallback(() => setAttempt((n) => n + 1), []);

  return { timedOut: pending && timedOut, restart };
};
